<template>
  <q-item class="q-mb-sm">
    <q-item-section>
      <q-item-label>
        <q-icon v-if="value" :name="symOutlinedCheck" color="green-6" size="xs"></q-icon>
        <q-icon v-else :name="symOutlinedCancel" color="red-6" size="xs"></q-icon>
      </q-item-label>
      <q-item-label v-if="caption" caption>{{ caption }}</q-item-label>
    </q-item-section>
    <q-item-section side> </q-item-section>
  </q-item>
</template>

<script setup>
import { symOutlinedCancel, symOutlinedCheck } from "@quasar/extras/material-symbols-outlined";
defineProps({
  caption: { type: [String, Number], required: false },
  value: { type: Boolean, required: false },
});
</script>
